/* The Putting Room: sticky credit+cart dock and the store credit sheet. */
(() => {
  const header = document.querySelector('.tpr-header');
  const dock = document.querySelector('[data-tpr-dock]');

  // Pin the credit button and cart once the header has scrolled out of view.
  if (header && dock && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      ([entry]) => {
        const docked = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        dock.classList.toggle('is-docked', docked);
      },
      { threshold: 0 }
    ).observe(header);
  }

  const sheet = document.querySelector('[data-tpr-credit-sheet]');
  if (!sheet) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const store = {
    get(key) {
      try { return window.localStorage.getItem(key); } catch (e) { return null; }
    },
    set(key, value) {
      try { window.localStorage.setItem(key, value); } catch (e) { /* storage unavailable */ }
    },
  };

  const showStep = (name) => {
    sheet.querySelectorAll('[data-tpr-credit-step]').forEach((el) => {
      el.hidden = el.dataset.tprCreditStep !== name;
    });
  };

  const slotEmail = (email) => {
    const slot = sheet.querySelector('[data-tpr-credit-email]');
    if (slot) slot.textContent = email;
  };

  // Back from the sign-up post: Shopify adds customer_posted=true on success.
  const posted = /[?&]customer_posted=true/.test(window.location.search);
  if (posted && store.get('tpr_credit_pending')) {
    store.set('tpr_credit_email', store.get('tpr_credit_pending'));
  }

  const claimedEmail = store.get('tpr_credit_email');
  if (claimedEmail && sheet.querySelector('[data-tpr-credit-step="done"]')) {
    slotEmail(claimedEmail);
    showStep('done');
  }

  // Open the sheet straight away after a sign-up post, or when the form came back with an error.
  const serverError = sheet.querySelector('#tpr-credit-form .tpr-sheet__error');
  if ((posted && claimedEmail) || serverError) {
    window.requestAnimationFrame(() => open());
  }

  function open() {
    if (sheet.open) return;
    sheet.showModal();
    if (reduced) {
      sheet.classList.add('is-in');
      return;
    }
    window.requestAnimationFrame(() => window.requestAnimationFrame(() => sheet.classList.add('is-in')));
  }

  function close() {
    if (!sheet.open) return;
    sheet.classList.remove('is-in');
    const panel = sheet.querySelector('.tpr-sheet__panel');
    if (reduced || !panel) {
      sheet.close();
      return;
    }
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      sheet.close();
    };
    panel.addEventListener('transitionend', finish, { once: true });
    window.setTimeout(finish, 600);
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-tpr-credit-open]')) {
      event.preventDefault();
      open();
    } else if (event.target.closest('[data-tpr-credit-close]')) {
      close();
    }
  });

  // Click on the dimmed backdrop closes; Esc animates closed too.
  sheet.addEventListener('click', (event) => {
    if (event.target === sheet) close();
  });
  sheet.addEventListener('cancel', (event) => {
    event.preventDefault();
    close();
  });

  // The form posts normally so Shopify's spam check (invisible captcha) can run; we only remember the email.
  const form = sheet.querySelector('#tpr-credit-form');
  if (form) {
    form.addEventListener('submit', () => {
      const input = form.querySelector('input[type="email"]');
      if (input && input.value) store.set('tpr_credit_pending', input.value.trim());
      const submit = form.querySelector('[type="submit"]');
      if (submit) submit.setAttribute('aria-busy', 'true');
    });
  }
})();
